import * as React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    'icon-wrapper': {
      width: '32px',
      height: '32px',
      borderRadius: '100%',
      backgroundColor: theme.palette.primary[50],
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    'title-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    title: {
      fontSize: '24px',
      lineHeight: 1.3,
      fontWeight: 600,
    },
    description: {
      fontSize: '16px',
      lineHeight: 1.3,
      fontWeight: 400,
    },
  }
})
type HeaderWithIconProps = {
  iconUrl: string
  title: string
  description?: string
  className?: string
}

const HeaderWithIcon: React.FC<HeaderWithIconProps> = ({ iconUrl, title, description, className }) => {
  const classes = useStyles()
  return (
    <div className={`${classes.root} ${className}`}>
      <div className={classes['icon-wrapper']}>
        <img src={iconUrl} alt={title} className={classes.icon} />
      </div>
      <div className={classes['title-wrapper']}>
        <h1 className={classes.title}>{title}</h1>
        {description && <p className={classes.description}>{description}</p>}
      </div>
    </div>
  )
}

export default HeaderWithIcon
